angular.module("Main").controller("MainController", ["$window", "$location", "$document", "$state", "$stateParams", "BookingService", "SessionService", "AuthenticationService",
    function ($window, $location, $document, $state, $stateParams, BookingService, SessionService, AuthenticationService) {
        var vm = this;

        vm.actualYear = moment().year();

        AuthenticationService.checkVersion($location.path(), $location.search().club).then(function (check) {
            if (!check.valid)
                window.location = check.url;
        }).catch(function () {
            $state.go("no_access"); // error loading data
        });

        if (window.location !== window.parent.location) {
            //wenn kein iframe dann zeig den Footer/Impressum & Datenschutz
            vm.isFrame = true;
        } else {
            vm.isFrame = false;
        }

        //var clubId = $location.search().cid;
        if (_.isEmpty($location.search().cid)) {
            var clubId = $stateParams.cid;
            vm.clubId = $stateParams.cid;
        } else {
            var clubId = $location.search().cid;
            vm.clubId = $location.search().cid;
        }

        if (_.isEmpty($location.search().dt)) {
            var dt = $stateParams.dt;
            vm.dt = $stateParams.dt;
        } else {
            var dt = $location.search().dt;
            vm.dt = $location.search().dt;
        }

        if (_.isEmpty($location.search().id) || $location.search().id == "undefined" || !_.isEmpty($location.search().cc)) {
            var linkId = false;
            vm.linkId = false;
        } else {
            var linkId = $location.search().id;
            vm.linkId = $location.search().id;
        }

        if (!_.isEmpty(clubId)) {
            SessionService.setAuthData(clubId, linkId);
        } else {
            $state.go("no_access", {cid: 0, loginResponseNull: 0, loginError: 0, urlIncomplete: 0, main: 1}); // error loading data
            return;
        }

        if ($location.path() === "/customer" || $state.is("/customer")) {
            vm.isKundenportal = true;
            $state.go("customer", {cid: clubId});
        }
        if ($location.path() === "/kursplan" || $location.path() === "/uebersichtkurs" || $state.is("/kursbuchungubersicht") || $state.is("/meineterminekurs") || $location.path() === "/meineterminekurs") {
            vm.isKurse = true;
            $state.go("kursplan", {cid: clubId, id: linkId});
        }
        if ($location.path() === "/angebot" || $location.path() === "/termin" || $location.path() === "/uebersicht" || $state.is("/meineterminetermin") || $location.path() === "/meineterminetermin") {
            vm.isTermine = true;
            $state.go("angebot", {cid: clubId, id: linkId});
        }

        if ($location.path() === "/shop" || $location.path() === "/shop/overview" || $state.is("/shop") || $location.path() === "/shop_overview") {
            vm.isShop = true;
            $state.go("shop", {cid: clubId, id: linkId});
        }

        init();

        async function init() {

            var clubId = $location.search().cid;
            if (_.isEmpty($location.search().id) || $location.search().id === "undefined" || !_.isEmpty($location.search().cc)) {
                var linkId = false;
            } else {
                var linkId = $location.search().id;
            }

            if ($location.path() === "/autotermine" || $location.path() === "/autokurse" || $location.path() === "/autologin" || $location.path() !== "/onlinesales" || $location.path() !== "/shop") {

                if ((!_.isEmpty(clubId) || !_.isEmpty($location.search().cid)) && (!_.isEmpty(linkId) || !_.isEmpty($location.search().id))) {
                    SessionService.setAuthData(clubId, linkId);
                    try {
                        await AuthenticationService.authenticate($document[0].referrer);
                    } catch (err) {
                        $state.go("no_access"); // not authenticated
                    }
                }
            } else if ($location.path() !== "/onlinesales" && !$state.is("surveysScrolled") && !$state.is("onlinesales") && !$state.is("onlinesalesClub") && $location.path() !== "/surveysScrolled") {
                if (!_.isEmpty(clubId)) {
                    SessionService.setAuthData(clubId);
                    $state.go("angebot", {cid: $location.search().cid, id: linkId});
                    try {
                        await AuthenticationService.authenticate($document[0].referrer);
                    } catch (err) {
                        $state.go("no_access"); // not authenticated
                    }
                }
                else {
                    $state.go("no_access"); // not authenticated
                }
            }
            else if ($location.path() === "/onlinesales" || $state.is("surveysScrolled") || $state.is("onlinesales") || $state.is("onlinesalesClub") || $location.path() === "/surveysScrolled") {
                if (!_.isEmpty(clubId) || !_.isEmpty($location.search().cid)) {
                    SessionService.setAuthData(clubId);

                    try {
                        await AuthenticationService.authenticate($document[0].referrer);
                    } catch (err) {
                        $state.go("no_access_online_sales"); // not authenticated
                    }
                }
                else {
                    $state.go("no_access_online_sales"); // not authenticated
                }
            }
            else if($state.is("shop") || $location.path() === "/shop") {
                if (!_.isEmpty(clubId) || !_.isEmpty($location.search().cid)) {
                    SessionService.setAuthData(clubId);

                    try {
                        await AuthenticationService.authenticate($document[0].referrer);
                    } catch (err) {
                        $state.go("no_access_shop"); // not authenticated
                    }
                }
                else {
                    $state.go("no_access_shop"); // not authenticated
                }
            }

            vm.clubId = $location.search().cid;
            vm.dt = $location.search().dt;
            if (_.isEmpty($location.search().id) || $location.search().id === "undefined" || !_.isEmpty($location.search().cc)) {
                vm.linkId = false;
            } else {
                vm.linkId = $location.search().id;
            }

            loadLayoutConfiguration();
            loadCurrency();
            getKursbuchungLayouKonfiguration();
            getAngeboteTexteConfiguration();


            if (vm.isTermine || vm.isKurse) {
                loadBezeichnungStudio();
                loadLogo();

            }
            else if (vm.isKundenportal) {
                loadKPBezeichnungStudio();
                loadLogo();
            }
            else if (vm.isShop) {
                loadShopLogo();
                loadBezeichnungStudioShop();
            }
            else {
                if($state.is("onlinesalesClub") || !_.isUndefined($stateParams.club) || $location.search().club) {
                    loadMandantMembershipBezeichnungStudio($location.search().club);
                    loadLogo();
                } else {
                    loadMembershipBezeichnungStudio();
                    loadLogo();
                }
            }


            AuthenticationService.isCenterCom().then(function (data) {
                vm.isCenterCom = data.isCenterCom;
            })
        }

        vm.toSelectView = {background: 'black', opacity: 0.6};

        function loadBezeichnungStudio() {
            BookingService.loadBezeichnungStudio(vm.isKurse, vm.linkId).then(function (data) {
                vm.linkBezeichnungStudio = data.BezeichnungStudio;
            })
        }

        function loadBezeichnungStudioShop() {
            BookingService.loadBezeichnungStudioShop(vm.linkId).then(function (data) {
                vm.linkShopBezeichnungStudio = data.BezeichnungStudio;
            })
        }

        function loadMembershipBezeichnungStudio() {
            BookingService.loadMembershipBezeichnungStudio(vm.linkId).then(function (data) {
                vm.linkMembershipBezeichnungStudio = data.BezeichnungStudio;
            })
        }

        function loadMandantMembershipBezeichnungStudio(mandantId) {
            BookingService.loadMandantMembershipBezeichnungStudio(mandantId).then(function (data) {
                vm.linkMembershipBezeichnungStudio = data.BezeichnungStudio;
            })
        }

        function loadKPBezeichnungStudio() {
            BookingService.loadKPBezeichnungStudio().then(function (data) {
                vm.KPBezeichnungStudio = data.BezeichnungStudioKundenportal;
            })
        }

        function  loadLogo() {
            BookingService.loadLogo(vm.linkId, !vm.isKurse && !vm.isTermine && !vm.isKundenportal ? 'osm' : vm.isKundenportal ? 'kp' : vm.isKurse, $location.search().club).then(function (data) {
                vm.logo = data;
            })
        }

        function loadShopLogo() {
            BookingService.loadShopLogo(vm.linkId).then(function (data) {
                vm.logo = data;
            })
        }

        function loadCurrency() {
            BookingService.getCurrency().then(function (data) {
                vm.currency = data;
                if (vm.currency.Waehrung === "EUR")
                    vm.currency.Waehrung = "€";
            })
        }

        function getAngeboteTexteConfiguration() {
            BookingService.getAngeboteTexteConfiguration().then(function (data) {
                vm.angebote = data;
            })

        }

        function loadLayoutConfiguration() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.selectedFont = vm.layoutSettings[7]["font-family"];
                vm.KursbuchungTimeSlider = data.KursbuchungTimeSlider;
                vm.TerminbuchungTimeSlider = data.TerminbuchungTimeSlider;
                vm.borderColorHeader = {borderColor: vm.layoutSettings[5].color};
                vm.welcomeText = data.WelcomeText;
                vm.privacytermsText = data.PrivacyPolicy;
                vm.successText = data.BookingHelpText;
                vm.registrierungZulassen = data.RegistrierungZulassen;
                vm.impressumUrl = data.ImpressumUrl;
                vm.datenschutzUrl = data.DatenschutzUrl;
                vm.studioBezeichnungFarbeBS = data.FarbeStudiobezeichnungBS ? data.FarbeStudiobezeichnungBS : vm.layoutSettings[5].color;
                vm.studioBezeichnungSizeBS = data.TextgroesseStudioBezeichnungBS + "px";
                vm.studioBezeichnungFarbeOSM = data.FarbeStudiobezeichnungOSM ? data.FarbeStudiobezeichnungOSM : vm.layoutSettings[5].color;
                vm.studioBezeichnungSizeOSM = data.TextgroesseStudioBezeichnungOSM + "px";
                vm.studioBezeichnungFarbeKP = data.FarbeStudiobezeichnungKP ? data.FarbeStudiobezeichnungKP : vm.layoutSettings[5].color;
                vm.studioBezeichnungSizeKP = data.TextgroesseStudioBezeichnungKP +"px";
                if (window.location !== window.parent.location) {
                    if (_.startsWith(vm.impressumUrl, "http") || _.startsWith(vm.impressumUrl, "https")) {
                        vm.impressumUrlWithout = true;
                    } else {
                        vm.impressumUrlWith = true;
                    }

                    // The page is in an iframe
                } else {
                    if (_.startsWith(vm.impressumUrl, "http") || _.startsWith(vm.impressumUrl, "https")) {
                        vm.impressumUrlNewTabWithout = true;
                    } else {
                        vm.impressumUrlNewTabWith = true;
                    }
                    // The page is not in an iframe
                }
            })
        }

        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            })
        }

    }]);